export const VEHICLE_STOCK_STATUS = {
    IN_STOCK: 10,
    SOLD: 20
};

export const VEHICLE_STOCK_SELLABLE = {
    UNSPECIFIED: 0,
    NOT_FOR_SALE: 1,
    FOR_SALE: 2
};

export const LISTING_STATUS = {
    ACTIVE: 10,
    COMPLETED: 20,
    CANCELLED: 30
};

export const REQUEST_STATUS = {
    PENDING: 10,
    APPROVED: 20,
    REJECTED: 30,
    CANCELLED: 40
};

export const REQUEST_ACTION = {
    APPROVE: 1,
    REJECT: 2
};

export const getStockStatusSeverity = (status) => {
    switch (status) {
        case VEHICLE_STOCK_STATUS.IN_STOCK:
            return 'success';
        case VEHICLE_STOCK_STATUS.SOLD:
            return 'secondary';
        default:
            return 'info';
    }
};

export const getSellableSeverity = (sellable) => {
    switch (sellable) {
        case VEHICLE_STOCK_SELLABLE.FOR_SALE:
            return 'success';
        case VEHICLE_STOCK_SELLABLE.NOT_FOR_SALE:
            return 'danger';
        case VEHICLE_STOCK_SELLABLE.UNSPECIFIED:
        default:
            return 'warning';
    }
};

export const getListingStatusSeverity = (status) => {
    switch (status) {
        case LISTING_STATUS.ACTIVE:
            return 'success';
        case LISTING_STATUS.COMPLETED:
            return 'info';
        case LISTING_STATUS.CANCELLED:
            return 'secondary';
        default:
            return 'info';
    }
};

export const getRequestStatusSeverity = (status) => {
    switch (status) {
        case REQUEST_STATUS.PENDING:
            return 'warning';
        case REQUEST_STATUS.APPROVED:
            return 'success';
        case REQUEST_STATUS.REJECTED:
            return 'danger';
        case REQUEST_STATUS.CANCELLED:
            return 'secondary';
        default:
            return 'info';
    }
};

export const REFUND_ORDER_STATUS = {
    DRAFT: 5,
    WAITING_APPROVAL: 10,
    REJECTED: 20,
    APPROVED: 30
};

export const REFUND_APPROVAL_ACTION = {
    APPROVE: 1,
    REJECT: 2
};

export const getRefundStatusSeverity = (status) => {
    switch (status) {
        case REFUND_ORDER_STATUS.DRAFT:
            return 'warning';
        case REFUND_ORDER_STATUS.WAITING_APPROVAL:
            return 'info';
        case REFUND_ORDER_STATUS.APPROVED:
            return 'success';
        case REFUND_ORDER_STATUS.REJECTED:
            return 'danger';
        default:
            return 'info';
    }
};
